import { useEditor, type Tool } from "../store/editor.js";

const TOOLS: { id: Tool; label: string; key: string }[] = [
  { id: "select", label: "Select", key: "V" },
  { id: "road", label: "Road", key: "R" },
  { id: "building", label: "Building", key: "B" },
];

export function Toolbar(): React.ReactElement {
  const { tool, setTool, undo, redo, canUndo, canRedo, dirty, doc } = useEditor();

  return (
    <div style={toolbarStyle}>
      <div style={leftGroupStyle}>
        <span style={titleStyle}>Maps</span>
        <span style={docNameStyle}>
          {doc.name}
          {dirty ? " *" : ""}
        </span>
      </div>

      <div style={toolGroupStyle}>
        {TOOLS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTool(t.id)}
            style={tool === t.id ? activeBtnStyle : btnStyle}
            title={`${t.label} (${t.key})`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div style={rightGroupStyle}>
        <button
          onClick={undo}
          disabled={!canUndo()}
          style={btnStyle}
          title="Undo (Cmd+Z)"
        >
          Undo
        </button>
        <button
          onClick={redo}
          disabled={!canRedo()}
          style={btnStyle}
          title="Redo (Cmd+Shift+Z)"
        >
          Redo
        </button>
        <span style={featureCountStyle}>
          {doc.features.length} features
        </span>
      </div>
    </div>
  );
}

const toolbarStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 12,
  padding: "6px 12px",
  background: "#181820",
  borderBottom: "1px solid #2a2a35",
  height: 42,
  flexShrink: 0,
  userSelect: "none",
};

const leftGroupStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 12,
};

const rightGroupStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginLeft: "auto",
};

const toolGroupStyle: React.CSSProperties = {
  display: "flex",
  gap: 4,
};

const titleStyle: React.CSSProperties = {
  fontWeight: 700,
  fontSize: 14,
  color: "#e0e0f0",
};

const docNameStyle: React.CSSProperties = {
  fontSize: 13,
  color: "#8888aa",
};

const featureCountStyle: React.CSSProperties = {
  fontSize: 12,
  color: "#666680",
};

const btnStyle: React.CSSProperties = {
  background: "#2a2a38",
  color: "#cccce0",
  border: "1px solid #383850",
  borderRadius: 4,
  padding: "4px 10px",
  fontSize: 13,
  cursor: "pointer",
};

const activeBtnStyle: React.CSSProperties = {
  ...btnStyle,
  background: "#4466ff",
  color: "#fff",
  borderColor: "#5588ff",
};